var _PluckObservableClass_key;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { Maybe } from '@noshiro/ts-utils';
import { SyncChildObservableClass } from '../class';
export const pluck = (key) => (parentObservable) => new PluckObservableClass(parentObservable, key);
export const pluckI = (key) => pluck(key);
class PluckObservableClass extends SyncChildObservableClass {
    constructor(parentObservable, key) {
        super({
            parents: [parentObservable],
            type: 'pluck',
            currentValueInit: Maybe.map((x) => x[key])(parentObservable.currentValue),
        });
        _PluckObservableClass_key.set(this, void 0);
        __classPrivateFieldSet(this, _PluckObservableClass_key, key, "f");
    }
    tryUpdate(token) {
        const par = this.parents[0];
        if (par.token !== token)
            return; // skip update
        if (Maybe.isNone(par.currentValue))
            return; // skip update
        this.setNext(par.currentValue.value[__classPrivateFieldGet(this, _PluckObservableClass_key, "f")], token);
    }
}
_PluckObservableClass_key = new WeakMap();
